import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SafeStyle } from '@angular/platform-browser';
import { PanelComponent, Register } from '@xanadu/core';
import { Syndicate } from '@xanadu/model';

@Component({
    selector: 'app-syndicate-panel',
    templateUrl: './syndicate-panel.component.html',
    styleUrls: ['./syndicate-panel.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[style]': 'hostStyle'
    }
})
@Register('syndicate-panel')
export class SyndicatePanelComponent extends PanelComponent<Syndicate> {
    private tabRealm = { caption: 'Syndicate', active: true, hidden: false };

    hostStyle: SafeStyle = 'height: 100%';

    protected override get nodeType(): string | undefined {
        return 'import';
    }

    protected override setup(syndicate: Syndicate): void {
        super.setup(syndicate);

        this.tabs = [
            this.tabRealm
        ];
        this.tabSelected = this.tabRealm;
    }
}
